import React from "react";
import { Routes, Route, NavLink } from "react-router-dom";
import BuyerPage from "./BuyerPage";
import AdminPage from "./AdminPage";

const signUrl = "https://customer-assets.emergentagent.com/job_portal-prism-guild/artifacts/qpfvf9oi_For%20emergent.png";

export default function ApothecaryApp() {
  return (
    <div className="relative min-h-[calc(100vh-56px)] bg-[#070708] text-amber-50 overflow-hidden">
      {/* Subtle cool blue glow ambience */}
      <div aria-hidden className="apothecary-blue-glow" />

      <header className="relative z-10 border-b border-[#3f2a1b]/80 bg-[radial-gradient(circle_at_top,_#2b1b10_0%,_#0a0706_55%,_#050404_100%)] shadow-[0_12px_35px_rgba(0,0,0,0.8)]">
        <div className="section flex items-center gap-4 py-4">
          <img
            src={signUrl}
            alt="The Blind Apothecary sign"
            className="w-16 h-16 object-cover rounded-md border border-amber-700/60 shadow-lg"
          />
          <div>
            <h1 className="text-2xl sm:text-3xl font-semibold tracking-wide text-amber-100">
              The Blind Apothecary
            </h1>
            <p className="text-amber-200/80 text-sm">
              Herbalism • Alchemy • Scribing orders for Ashes of Creation
            </p>
          </div>
          <nav className="ml-auto flex gap-2 text-sm">
            <NavLink
              to="/apothecary"
              end
              className={({ isActive }) =>
                `px-3 py-2 rounded-md border border-transparent hover:border-amber-700/60 hover:bg-amber-900/30 ${
                  isActive ? "bg-amber-900/50 border-amber-600 text-amber-100" : "text-amber-200/90"
                }`
              }
            >
              Shop
            </NavLink>
            <NavLink
              to="/apothecary/admin"
              className={({ isActive }) =>
                `px-3 py-2 rounded-md border border-transparent hover:border-amber-700/60 hover:bg-amber-900/30 ${
                  isActive ? "bg-amber-900/50 border-amber-600 text-amber-100" : "text-amber-200/90"
                }`
              }
            >
              Admin
            </NavLink>
          </nav>
        </div>
      </header>

      <main className="section py-8">
        <Routes>
          <Route index element={<BuyerPage />} />
          <Route path="admin" element={<AdminPage />} />
        </Routes>
      </main>
    </div>
  );
}
